import { Component, Input } from '@angular/core';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { InstallerPassModel } from '@bo-client/shared/models/installerPassDto';
import { ConnectionObject } from '@bo-client/shared/models/connectionObject';
import { ContactData } from '@bo-client/shared/models/contactData';
import { UserDto } from '@bo-client/shared/models/userDto';

@Component({
  selector: 'app-show-create-update-connection-object-contact-data',
  templateUrl: './show-create-update-connection-object-contact-data.component.html',
  styleUrl: './show-create-update-connection-object-contact-data.component.scss'
})
export class ShowCreateUpdateConnectionObjectContactDataComponent {
  @Input() createUpdateEntity: (RequestModel | InstallerPassModel) & {
    connectionObject?: ConnectionObject;
    customer?: ContactData;
    technician?: UserDto;
  };
}
